import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import AsyncStorage  from '@react-native-async-storage/async-storage';
import { StyleSheet, View, Platform, TouchableOpacity } from 'react-native';
import { Screen, Button, Input, Line, Routes, Icon, Text } from '../components';
import { HomePetsList } from '../containers';
import PetController from '../controllers/petController';
import AuthController from '../controllers/authController';
import { useNavigate } from 'react-router-dom';

class SettingsScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      has_password: false
    }
  }

  async componentDidMount() {
    let user = await AuthController.getUser(true);

    if(user) {
      this.setState({
        has_password: user.has_password,
        user: user
      })
    }
  }

  render() {
    return (
      <Screen navigation={this.props.navigation} title={'Settings'} scroll={true}>
        <View style={{ padding: 20 }}>

          <TouchableOpacity onPress={ () => { this.props.navigate(Routes.SETTINGS_USER_PROFILE) }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>User Profile</Text>
            <Icon name='chevron-right' size={15} solid={true} color={'#cccccc'} />
          </TouchableOpacity>

          <Line style={{  }} />

          <TouchableOpacity onPress={ () => { this.props.navigate(Routes.SETTINGS_CHANGE_PHONE_NUMBER) }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>Change Phone Number</Text>
            <Icon name='chevron-right' size={15} solid={true} color={'#cccccc'} />
          </TouchableOpacity>

          <Line style={{  }} />

          { /*

          <TouchableOpacity onPress={ () => { this.props.navigate(Routes.SETTINGS_CHANGE_PAYMENT) }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>Change Payment Method</Text>
            <Icon name='chevron-right' size={15} solid={true} color={'#cccccc'} />
          </TouchableOpacity>

          <Line style={{  }} />


          <TouchableOpacity onPress={ () => { this.props.navigate(Routes.SETTINGS_CHANGE_PASSWORD) }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>{this.state.has_password ? 'Change' : 'Set'} Password</Text>
            <Icon name='chevron-right' size={15} solid={true} color={'#cccccc'} />
          </TouchableOpacity>
          */}

          <Line style={{  }}  hide={true} />

          <TouchableOpacity onPress={ () => { this.props.navigate(Routes.SETTINGS_CONTACT_SUPPORT) }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>Contact Support</Text>
            <Icon name='chevron-right' size={15} solid={true} color={'#cccccc'} />
          </TouchableOpacity>

          <Line style={{  }} />

          <TouchableOpacity onPress={ async () => {
                                      await AuthController.signOut();
                                      this.props.onSignOut(false);
                                      if (Platform.OS === 'web') {
                                        this.props.navigate(Routes.HOME)
                                      } else {
                                        if (this.props.navigation) {
                                          this.props.navigation.navigate(Routes.HOME);
                                        } else {
                                          this.props.navigate(Routes.HOME);
                                        }
                                      }
                                    }}
                            style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={styles.row_title}>Sign Out</Text>
          </TouchableOpacity>

          <Line style={{  }} />

        </View>
      </Screen>
    );
  }

}

function SettingsScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsScreen_Base {...props} navigate={props.navigation.push} navigation={props.navigation} />
  }
}

const styles = StyleSheet.create({
  row_title: {
    fontSize: 16,
    fontWeight: '500',
    color: '#040415'
  }
});

export default SettingsScreen
